import { HighlightPattern } from './types';

export function createHighlightRegex(pattern: string): RegExp | null {
  try {
    if (pattern.startsWith('/') && pattern.includes('/', 1)) {
      const lastSlash = pattern.lastIndexOf('/');
      const regexPattern = pattern.slice(1, lastSlash);
      const flags = pattern.slice(lastSlash + 1);
      return new RegExp(
        regexPattern,
        flags.includes('g') ? flags : flags + 'g',
      );
    }
    return new RegExp(pattern, 'gi');
  } catch {
    return null;
  }
}

export function textHasHighlightMatches(
  text: string,
  patterns: HighlightPattern[],
): boolean {
  const validPatterns = patterns.filter((pattern) => pattern.regex);

  if (validPatterns.length === 0) {
    return false;
  }

  for (const pattern of validPatterns) {
    const regex = createHighlightRegex(pattern.regex);
    if (regex && regex.test(text)) {
      return true;
    }
  }

  return false;
}

export function textHasHighlightMatchesAfterOffset(
  text: string,
  patterns: HighlightPattern[],
  offset: number,
): boolean {
  if (offset >= text.length) return false;

  const validPatterns = patterns.filter((pattern) => pattern.regex);
  if (validPatterns.length === 0) return false;

  for (const pattern of validPatterns) {
    const regex = createHighlightRegex(pattern.regex);
    if (!regex) continue;
    regex.lastIndex = 0;
    let match: RegExpExecArray | null;
    while ((match = regex.exec(text)) !== null) {
      if (match.index + match[0].length > offset) return true;
      if (match.index === regex.lastIndex) regex.lastIndex++;
    }
  }
  return false;
}
